var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_795_1529)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.60938 12.4688H4.73438V10.5938H6.60938V12.4688ZM10.1719 10.5938H8.29688V12.4688H10.1719V10.5938ZM6.60938 14.1562H4.73438V16.0312H6.60938V14.1562ZM10.1719 14.1562H8.29688V16.0312H10.1719V14.1562ZM4.73438 19.5938H6.60938V17.7188H4.73438V19.5938ZM8.29688 19.5938H10.1719V17.7188H8.29688V19.5938ZM17.5312 13.6875C16.6511 13.6875 15.9375 14.4011 15.9375 15.2812C15.9375 16.1614 16.6511 16.875 17.5312 16.875C18.4114 16.875 19.125 16.1614 19.125 15.2812C19.125 14.4011 18.4114 13.6875 17.5312 13.6875ZM23.25 15.2816V15.5832C23.25 17.1627 22.3696 18.9893 20.6334 21.0126C19.3997 22.4502 18.1793 23.462 18.128 23.5043L17.5312 23.9967L16.9345 23.5043C16.8832 23.462 15.6628 22.4502 14.4291 21.0126C12.6929 18.9893 11.8125 17.1627 11.8125 15.5832V15.2816C11.8125 12.1282 14.378 9.5625 17.5312 9.5625C20.6845 9.5625 23.25 12.128 23.25 15.2816ZM21.375 15.2816C21.375 13.162 19.6507 11.4375 17.5312 11.4375C15.4118 11.4375 13.6875 13.162 13.6875 15.2816V15.5832C13.6875 16.6862 14.436 18.1415 15.8522 19.7917C16.474 20.5162 17.0973 21.1271 17.534 21.5314C18.9813 20.1958 21.375 17.5704 21.375 15.583V15.2816ZM14.6863 24H3.51562C1.96472 24 0.703125 22.7384 0.703125 21.1875V2.8125C0.703125 1.2616 1.96472 0 3.51562 0H18.4219C19.9728 0 21.2344 1.2616 21.2344 2.8125V8.65375C20.6647 8.33423 20.0499 8.08667 19.402 7.92188H2.57812V21.1875C2.57812 21.7044 2.99872 22.125 3.51562 22.125H12.9142C12.9448 22.1613 12.975 22.1975 13.0062 22.2338C13.604 22.9303 14.2022 23.5371 14.6863 24ZM2.57812 2.8125V6.04688H19.3594V2.8125C19.3594 2.29559 18.9388 1.875 18.4219 1.875H3.51562C2.99872 1.875 2.57812 2.29559 2.57812 2.8125Z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_795_1529"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }